import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { aiAgentQueryKeys } from "app/pages/sales-intelligence/modules/ai-agent/queries/queryKeyFactory";
import type { Competitor } from "app/pages/sales-intelligence/modules/ai-agent/types/meeting";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

export const useGetCompetitors = (domain: string, enabled: boolean = true): UseQueryResult<Competitor[]> => {
    return useQuery({
        queryKey: aiAgentQueryKeys.competitors(domain),
        queryFn: async ({ signal }) => {
            const data = await salesApiService.aiAgent.meeting.getCompetitors({ domain }, { cancellation: signal });
            return data.competitors;
        },
        enabled: enabled,
    });
};
